var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"py-0 pr-0 d-flex align-center justify-start"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.display && _vm.isMediumBreakpointOrLarger)?_c('span',{staticClass:"ml-2 primary--text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }